import React from 'react';

interface GaphenLoadingMaskProps {
    fullScreen?: boolean;
}

const GaphenLoadingMask: React.FC<GaphenLoadingMaskProps> = ({
    fullScreen = true,
}) => {
    return (
        <div
            className={`${
                fullScreen ? 'fixed inset-0' : 'absolute inset-0'
            } z-[9999] flex items-center justify-center bg-gradient-to-br from-emerald-50 via-amber-50 to-emerald-100 dark:from-emerald-950 dark:via-amber-950 dark:to-emerald-900 backdrop-blur-md`}
        >
            <div className="w-full max-w-xl transform px-4 text-center transition-all duration-700 ease-out">
                <div className="mx-auto mb-6">
                    {/* Container for spinners and logo with responsive sizing */}
                    <div className="relative mx-auto h-32 w-32 sm:h-40 sm:w-40 md:h-48 md:w-48">
                        {/* Outer spinner */}
                        <div className="absolute inset-0 animate-[spin_4s_linear_infinite]">
                            <svg
                                className="h-full w-full"
                                viewBox="0 0 100 100"
                            >
                                <circle
                                    cx="50"
                                    cy="50"
                                    r="45"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    className="text-emerald-600/40 dark:text-emerald-400/40"
                                    strokeDasharray="70 30"
                                />
                            </svg>
                        </div>

                        {/* Inner spinner */}
                        <div className="absolute inset-4 animate-[spin_3s_linear_infinite_reverse]">
                            <svg
                                className="h-full w-full"
                                viewBox="0 0 100 100"
                            >
                                <circle
                                    cx="50"
                                    cy="50"
                                    r="45"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    className="text-amber-600/40 dark:text-amber-400/40"
                                    strokeDasharray="50 50"
                                />
                            </svg>
                        </div>

                        {/* Centered logo */}
                        <div className="absolute inset-8 sm:inset-10 md:inset-12">
                            <img
                                src="/images/logo.png"
                                alt="Gaphen Logo"
                                className="h-full w-full animate-pulse object-contain"
                            />
                        </div>
                    </div>
                </div>

                <div className="animate-[fadeIn_1s_ease-out]">
                    <h2 className="bg-gradient-to-r from-emerald-600 to-amber-600 dark:from-emerald-400 dark:to-amber-400 bg-clip-text text-xl font-bold text-transparent sm:text-2xl">
                        Inducing Prosperity
                    </h2>
                    <p className="mt-2 animate-pulse text-sm font-medium text-emerald-600/80 dark:text-emerald-400/80 sm:text-base">
                        Empowering smallholder farmers through innovative
                        solutions.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default GaphenLoadingMask;